<template>
    <!-- mailaddress -->
    <div class="p-mypage__account p-mypage__account--mailaddress mypage-bloc">
        <div class="mypage-bloc__head">
            <h2>{{ $t('LABEL_MAIL_INFO_TITLE') }}</h2>
        </div>
        <div class="mypage-bloc__content">
            <div class="mailaddress__setting">
                <div class="text">
                    <p>{{ $t('LABEL_MAIL_INFO_MESSAGE') }}</p>
                    <dl>
                        <dt>{{ $t('LABEL_MAIL_ADDRESS') }}</dt>
                        <dd>{{ userStore.getEditAccountParams.email }}</dd>
                    </dl>
                </div>
                <div class="setting">
                    <button class="c-btn__account c-btn__account--mailaddress">{{ $t('LABEL_CHANGE_MAIL_ADDRESS') }}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>

import {useUserStore} from "@/stores/userStore";

const userStore = useUserStore();

</script>